import { useEffect } from 'react'

/**
 * Keeps <title> and the meta description in sync during client-side navigation.
 * The first paint's values are baked in by scripts/prerender.mjs, so this only
 * matters once the router takes over.
 */
export function useDocumentTitle(title: string, description?: string) {
  useEffect(() => {
    if (document.title !== title) document.title = title

    if (description) {
      const tag = document.querySelector('meta[name="description"]')
      if (tag) tag.setAttribute('content', description)
    }
  }, [title, description])
}
